import api from "@/api/api-v1-config";
import { IUrl } from "@/interfaces/IUrl";

const url: IUrl = window as never;

// Define URLs
const URL_REGISTRATION = url.urls.registration;
const URL_CHECK_CONFIRMATION_CODE = url.urls.checkConfirmationCode;
const URL_INCREASE_ATTEMPTS = url.urls.increaseAttempts;

/**
 * Регистрация
 * @param payload
 */
export async function registrationAxios(payload: { phone: string }) {
	return await api.post(URL_REGISTRATION, payload);
}

/**
 * Проверка кода подтверждения
 * @param payload
 */
export async function checkConfirmationCodeAxios(payload: {
	code: string;
	phone: string;
	action: string;
}) {
	return await api.post(URL_CHECK_CONFIRMATION_CODE, payload);
}

/**
 * Увеличить количество попыток (attempts)
 * @param payload
 */
export async function increaseAttemptsAxios(payload: {
	phone: string;
	action: string;
}) {
	return await api.post(URL_INCREASE_ATTEMPTS, payload);
}
